// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * APPEND-ONLY. The members below carry no explicit `= N`, so `FlatBuffers`
 * numbers them by declaration order and the ordinal IS the wire value.
 *
 * Inserting, reordering or removing a member silently renumbers every member
 * after it, which reinterprets every archived message and every frame in
 * flight — with no error anywhere, because the wire value stays a valid
 * member of the enum, just a different one. New values go LAST, always.
 */
export enum GroupSupervisoryStatus {
  UpPeak = 0,
  DownPeak = 1,
  LobbyPeak = 2,
  HeavyTraffic = 3,
  Fire = 4,
  EmergencyPower = 5,
  PH1 = 6,
  HcPower = 7,
  HcComm = 8,
  Sec = 9,
  Balanced = 10,
  AutoBalance = 11,
  AutoLobby = 12,
  AutoDemandUp = 13,
  AutoDemandDown = 14,
  Normal = 15,
  Epd = 16,
  Evacuation = 17,
  Standby = 18,
  HallButtonPower = 19,
  Earthquake = 20,
  HallCallLocksOn = 21,
  HallCallLocksOff = 22,
  AlternateFire = 23,
  MainFire = 24,
  CommunicationProblem = 25,
  DownPeakTraffic = 26,
  EmergencyPowerEvacuation = 27,
  GroupSwitchOff = 28,
  LockTrip = 29,
  Miconic10 = 30,
  NoonPeakTraffic = 31,
  NormalTraffic = 32,
  TerminalFault = 33,
  TrafficMode = 34,
  UpPeakTraffic = 35,
  VirtualTerminal = 36,
  BlockOperation = 37,
  StatusNotAvailable = 38,
}
